import React, { useEffect, useState } from 'react';
import icons from '../../../icons';
import style from './OptionSelection.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useRef, useContext } from 'react';
import Banner from '../../Banner/Banner';
import TextButton from '../../Buttons/TextButton/TextButton';
import Checkbox from '../../Checkbox/Checkbox';
import { AppContext } from '../../../AppContext';


const addDays = (date, days) => {
    let newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

const getItalianMonth = month => {
    switch(month) {
        case 0:
            return "Gennaio";
        case 1:
            return "Febbraio";
        case 2:
            return "Marzo";
        case 3:
            return "Aprile";
        case 4:
            return "Maggio";
        case 5:
            return "Giugno";
        case 6:
            return "Luglio";
        case 7:
            return "Agosto";
        case 8:
            return "Settembre";
        case 9:
            return "Ottobre";
        case 10:
            return "Novembre";
        case 11:
            return "Dicembre";
    }
};

const OptionSelection = props => {
    const { setPage, subjects, timetable, user, users } = useContext(AppContext);

    const [calendar, setCalendar] = useState([]);
    const [startDate, setStartDate] = useState(props.value?.[0]);
    const [endDate, setEndDate] = useState(null);
    const [calendarActiveSlide, setCalendarActiveSlide] = useState(0);
    const [swiperLoaded, setSwiperLoaded] = useState(null);

    const swiper = useRef();

    const generateCalendar = () => {
        const now = new Date();
        let date = new Date(now.getFullYear() - 1, 0, 1);
        let weeks = [];
        let week = -1;

        while (date.getDay() !== 1)
            date = addDays(date, 1);

        while (date.getFullYear() <= now.getFullYear() + 1) {
            if (date.getDay() === 1)
                week += 1;

            if (!weeks[week])
                weeks.push([]);

            weeks[week].push(date);
            date = addDays(date, 1);
        }

        setCalendar(weeks);
        return weeks;
    };

    const compareDates = (firstDate, secondDate, strict=false) => {
        if (!firstDate || !secondDate) 
            return false;

        if (strict)
            return firstDate.getTime() === secondDate.getTime();
        
        return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
    };

    const dateInPeriod = (start, date, end) => {
        if (!start || !date || !end)
            return false;

        return start.getTime() < date.getTime() && date.getTime() < end.getTime();
    };

    const isSubjectInDate = (subject, date) => {
        const dayTimetable = timetable?.[date.getDay()];
        if (!dayTimetable)
            return false;

        return Object.values(dayTimetable).filter(({ subjectTitle }) => subjectTitle === subject).length > 0;
    };

    // useEffect(() => {
    //     console.log(props.option)
    //     if (props.option === "date")
    //         setStartDate(props.value?.[0])
    // }, [props.value]);

    useEffect(() => {
        setEndDate(null);
    }, [props.selectedOptions.type]);

    useEffect(() => {
        generateCalendar();
    }, []);

    useEffect(() => {
        const today = new Date();
        calendar.forEach(week => week.forEach(day => {
            if (!startDate) {
                if (day.getDate() === today.getDate() && day.getMonth() === today.getMonth() && day.getFullYear() === today.getFullYear()) {
                    setCalendarActiveSlide(calendar.indexOf(week));
                    swiper.current?.swiper?.slideTo(calendar.indexOf(week));
                }
            } else if (day.getDate() === startDate.getDate() && day.getMonth() === startDate.getMonth() && day.getFullYear() === startDate.getFullYear()) {
                setCalendarActiveSlide(calendar.indexOf(week));
                swiper.current?.swiper?.slideTo(calendar.indexOf(week));
            }
        }));
    }, [calendar, swiperLoaded, props.option]);

    return <main className={ style.main } style={{ height: props.option && "100vh" }}>
        { (() => {
            switch (props.option) {
                case "subject":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2>Scegli la <span style={{ color: "var(--orange)" }}>materia</span></h2>
                                <img src={ icons.add_icon } className={ style.addIcon } onClick={ () => setPage({ page: "menu", menuPage: "subjects", from: "add" }) }></img>
                            </div>
                            <h3 className={ style.subHeader }>O aggiungine una nuova</h3>
                            <Banner />
                        </section>
                        <div className={ style.subjects }>
                            { subjects && Object.values(subjects).map(subject => <div key={ subject.subject } className={ style.subject } onClick={ () => props.select(subject.subject) }>
                                <img src={ icons[subject.icon] } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>{ subject.subject }</h3>
                            </div>) }
                            {/* <div className={ style.subject } onClick={ () => props.select("Fisica") }>
                                <img src={ icons.physics_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Fisica</h3>
                            </div>                            */}
                        </div>
                    </>;
                case "type":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2 style={{ marginTop: ".5rem" }}>Scegli il <span style={{ color: "var(--orange)" }}>tipo</span> di evento</h2>
                            </div>
                            <Banner style={{ marginTop: "1rem" }} />
                        </section>
                        <div className={ style.subjects }>
                            <div className={ style.subject } onClick={ () => props.select("test") }>
                                <img src={ icons.test_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Verifica</h3>
                            </div>
                            <div className={ style.subject } onClick={ () => props.select("interrogation") }>
                                <img src={ icons.interrogation_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName } style={{ marginTop: "1.75rem" }}>Orale</h3>
                            </div>
                            <div className={ style.subject } onClick={ () => props.select("homework") }>
                                <img src={ icons.home_orange_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Per casa</h3>
                            </div>
                            <div className={ style.subject } onClick={ () => props.select("other") }>
                                <img src={ icons.question_mark_orange_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Altro</h3>
                            </div>
                        </div>
                    </>;
                case "date":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2 style={{ marginTop: ".5rem" }}>Scegli l{ props.selectedOptions.type === "interrogation" ? "e" : "a" } <span style={{ color: "var(--orange)" }}>dat{ props.selectedOptions.type === "interrogation" ? "e" : "a" }</span></h2>
                            </div>
                            <Banner style={{ marginTop: "1rem" }} />
                        </section>
                        <div className={ style.calendar }>
                            <h3 className={ style.month }>{ getItalianMonth(calendar[calendarActiveSlide][0].getMonth()) } { calendar[calendarActiveSlide][0].getFullYear() }</h3>
                            <div className={ style.week } style={{ background: "rgb(80, 80, 80)", marginBottom: "1rem", borderRadius: ".5rem" }}>
                                <p className={ style.day }>L</p>
                                <p className={ style.day }>M</p>
                                <p className={ style.day }>M</p>
                                <p className={ style.day }>G</p>
                                <p className={ style.day }>V</p>
                                <p className={ style.day }>S</p>
                                <p className={ style.day }>D</p>
                            </div>
                            <Swiper direction='vertical' slidesPerView={ 4 } style={{ height: "26vh" }} ref={ swiper } onSwiper={ () => setSwiperLoaded(true) } onSlideChange={ ({ activeIndex }) => setCalendarActiveSlide(activeIndex) }>
                                { calendar.map((week, index) => <SwiperSlide key={ index } style={{ height: "5vh", marginTop: "1.5vh" }}>
                                    <div className={ style.week }>
                                        { week.map(day => <p key={ `${day.getDate()}-${day.getMonth()}` } className={ [style.day, dateInPeriod(startDate, day, endDate) && props.selectedOptions.type === "interrogation" && style.period, (compareDates(day, startDate) || (props.selectedOptions.type === "interrogation" && compareDates(day, endDate))) && style.selected, !isSubjectInDate(props.selectedOptions.subject, day) && style.disabled].join(" ") } onClick={ () => {
                                            if (!timetable?.[day.getDay()] || Object.keys(timetable?.[day.getDay()]).length === 0) {
                                                props.setError({ show: true, error: "Non hai nessuna lezione quel giorno!" });
                                                return;
                                            }

                                            if (props.selectedOptions.type !== "interrogation") {
                                                setStartDate(day);
                                                return;
                                            }

                                            if (endDate || !startDate) {
                                                setStartDate(day);
                                                setEndDate(null);
                                                return;
                                            }
                                            
                                            if (startDate && day.getTime() >= startDate.getTime())
                                                setEndDate(day);
                                        } }
                                        style={{ 
                                            borderTopRightRadius: !compareDates(startDate, endDate) && compareDates(startDate, day) && props.selectedOptions.type === "interrogation" && "0",
                                            borderBottomRightRadius: !compareDates(startDate, endDate) && compareDates(startDate, day) && props.selectedOptions.type === "interrogation" && "0",
                                            borderTopLeftRadius: !compareDates(startDate, endDate) && compareDates(endDate, day) && props.selectedOptions.type === "interrogation" && "0",
                                            borderBottomLeftRadius: !compareDates(startDate, endDate) && compareDates(endDate, day) && props.selectedOptions.type === "interrogation" && "0",
                                        }}>{ day.getDate() }</p>) }
                                    </div>
                                </SwiperSlide>) }
                            </Swiper>
                        </div>
                        <TextButton icon={ icons.check_icon } text="SALVA" style={{ width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "2rem", height: "3.5rem" }} textStyle={{ marginTop: "auto", marginBottom: "auto" }} fontSize="1.1rem" onClick={ () => {
                            if (props.selectedOptions.type !== "interrogation") {
                                props.select([startDate, endDate]);
                                return;
                            }

                            if (!endDate)
                                return;

                            const startDateToSave = new Date(startDate);
                            const endDateToSave = new Date(endDate);

                            startDateToSave.setUTCHours(0);
                            startDateToSave.setUTCMinutes(0);
                            startDateToSave.setDate(startDate.getDate());

                            endDateToSave.setUTCHours(21);
                            endDateToSave.setUTCMinutes(59);
                            endDateToSave.setDate(endDate.getDate());

                            props.select([startDateToSave, endDateToSave]);
                        } } />
                    </>;
                case "users":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2 style={{ marginTop: ".5rem" }}>Scegli gli <span style={{ color: "var(--orange)" }}>utenti</span></h2>
                            </div>
                            <Banner style={{ marginTop: "1rem" }} />
                        </section>
                        <div className={ style.users }>
                            <div className={ style.user }>
                                <Checkbox id="all" onChange={ ({ target }) => { props.select(target.checked ? null : user?.id)} } checked={ props.value.length === 0 } />
                                <img src={ icons.users_icon } className={ style.userIcon }></img>
                                <h4 className={ style.username }>Tutta la classe</h4>
                            </div>
                            <div style={{ height: props.value.length === 0 ? "0" : "100vh", transition: "height .5s ease" }}>
                                { users && Object.values(users).map(dataUser => <div key={ `user-${dataUser.id}` } className={ style.user }>
                                    <Checkbox id={ dataUser.id } onChange={ () => props.select(dataUser.id) } checked={ props.value.includes(dataUser.id) } />
                                    <img src={ dataUser.profilePicture|| `https://eu.ui-avatars.com/api/?name=${dataUser.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                    <h4 className={ style.username }>{ dataUser.username }</h4>
                                </div>) }
                                {/* <div className={ style.user }>
                                    <Checkbox id={ "userId" } />
                                    <img src={ icons.cartoon_avatar_icon } className={ style.userIcon }></img>
                                    <h4 className={ style.username }>Utente</h4>
                                </div> */}
                            </div>
                        </div>
                    </>;
            }
        })() }
    </main>
};

export default OptionSelection;
